module.exports = __webpack_public_path__ + "img/MGH-Gion-15-2440x1172.e7b79884.jpg";